import { gql } from 'graphql-request';
import { queryPresets } from 'src/queries/base';
import {
  NAMESPACE_LOAN_PRODUCTS,
  useReactQuery
} from 'src/queries/useQuery';
import { useRequestGQLQuery } from './useGraphQLQuery';
import { pathOr } from 'ramda';
import { fetchLocalConfig } from 'src/queries/localconfig';
import { getNamespaceName } from '../objects/namespaces';
import { canUseLocalDevelopmentConfig, LOCAL_ENVIRONMENT } from 'src/constants';
import { returnIsNotEmptyOrTrue } from 'src/utilities/hasValue';

const GET_PRODUCT_BY_NAMESPACE = gql`query describeNamespaceDrivenResources($object_meta: jsonb) {
    loan_products(where: {object_meta: {_contains: $object_meta}}) {
      product_name
      product_visual_name
      subproducts
      metadata
      }
  }`;

const useLocalProductsByNamespace = async (environment:string,namespace: string) => {
  const namespaceProductPath = `/data/customization/${environment}/${namespace}/config/LPD_loanproducts.json`
  const data = await fetchLocalConfig(namespaceProductPath)
  return { loan_products: pathOr([], ['data'], data) }
}

export const getLoanProductByNamespace = (
  variables: any,
  enabled: boolean = true
) => {
  return useReactQuery(
    [NAMESPACE_LOAN_PRODUCTS, variables],
    returnIsNotEmptyOrTrue(
      canUseLocalDevelopmentConfig,
      () => useLocalProductsByNamespace(LOCAL_ENVIRONMENT,getNamespaceName()),
      () => useRequestGQLQuery(GET_PRODUCT_BY_NAMESPACE, variables)
    ),
    {
      ...queryPresets.oneTimeFetch,
      enabled,
      retry: true,
    });
};
